/**
 * 仓储管理--》入库单管理
 */

export default {
  // 入库单编辑放开禁用逻辑
  warehouse_receipt_editable: ['84081','99801'], // 202511101416182509179
  // 定制仓储价格体系
  customized_warehouse_price_system: ['99801'], // 202511131630167806592
}
